export { default } from './CommunityBrandingBadge';
